/**
 * Ability.js
 * Base class for abilities
 */

export class Ability {
    /**
     * @public
     */
    constructor() {}

    /**
     * @public
     */
    destroy() {}
}
